import React from 'react';

export const CaptchaPage = React.lazy(() => import(/* webpackChunkName: "captcha-page" */ './CaptchaPage'));
